import * as React from 'react';

export interface FileSelectorProps {
    onFileSelected: (file: File | undefined, type: MediaType) => void;
    onFilesSelected?: (files: File[] | undefined, type: MediaType) => void;
    multipleFiles?: boolean;
}

export interface FileSelectorState {
}

export enum MediaType {
    VIDEO,
    IMAGE,
    SVG,
    AUDIO,
    ALL
}

export const getAllowedFileExtensions = (type: MediaType): string => {
    switch (type) {
        case MediaType.IMAGE:
            return '.jpg, .jpeg, .png, .svg'
        case MediaType.SVG:
            return '.svg'
        case MediaType.VIDEO:
            return '.mp4'
        case MediaType.AUDIO:
            return '.mp3, .wav'
        case MediaType.ALL:
            return ''
    }
}
export default class FileSelector extends React.Component<FileSelectorProps, FileSelectorState> {

    constructor(props: FileSelectorProps) {
        super(props);

        this.state = {
        }
    }

    private fileSelector: HTMLInputElement | undefined;
    private type: MediaType | undefined;

    public render() {
        return (null);
    }

    public openFileSelect = (type: MediaType) => {
        this.fileSelector = this.initFileSelector(type);
        this.fileSelector.click();
    }

    private initFileSelector = (type: MediaType): HTMLInputElement => {
        const fileSelector = document.createElement('input');
        this.type = type;
        fileSelector.setAttribute('type', 'file');
        fileSelector.addEventListener('change', this.loadFile);
        fileSelector.setAttribute('accept', getAllowedFileExtensions(type))
        if (this.props.multipleFiles)
            fileSelector.setAttribute('multiple', '');
        return fileSelector;
    }

    private loadFile = (e: any) => {
        const files = e.target.files;
        if (files && this.type !== undefined) {

            if (this.props.multipleFiles && this.props.onFilesSelected) {
                this.props.onFilesSelected(files, this.type);
            }
            else {
                this.props.onFileSelected(files[0], this.type);
            }
        }

    }

}
